export default __webpack_public_path__ + "63df7ead245cc4ec15d2234b76743e45.webp";